import React, { useEffect, useRef, useState } from "react";
import styles from "./ActivePropertySelectBox.module.scss";
import { Link, useParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";

const ActivePropertySelectBox = () => {
  const [allProperties, setAllProperties] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [showPropertyDropDown, setShowPropertyDropDown] = useState(false);
  const popupRef = useRef(null);

  const vendorToken = localStorage.getItem("token");

  const navigate = useNavigate();
  const location = useLocation();

  const { id: propertyId } = useParams();

  // console.log(propertyId);

  useEffect(() => {
    if (propertyId && allProperties.length > 0) {
      const findSelectedProperty = allProperties.find(
        (property) => property.id == propertyId
      );
      setSelectedProperty(findSelectedProperty?.id);
    } else {
      setSelectedProperty(propertyId);
    }
  }, [propertyId, allProperties]);

  // console.log(selectedProperty);

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  //   console.log(userDetails);

  // const getProperties = (id) => {
  //   const requestOptions = {
  //     headers: {
  //       "Content-Type": "application/json",
  //       key: "D4X50uU40Vz4pweFLEmsoiJy107iPfTD4ompprop1",
  //       Authorization: "Bearer " + localStorage.getItem("token"),
  //     },
  //     method: "GET",
  //     redirect: "follow",
  //   };

  //   fetch(
  //     `${process.env.REACT_APP_APP_URL}/api/v1/vendor/get-accommodation/${id}`,
  //     requestOptions
  //   )
  //     .then((response) => response.json())
  //     .then((result) => {
  //       // console.log("result", result);

  //       if (result.success) {
  //         setAllProperties(result?.hotels);
  //       } else {
  //         setAllProperties([]);
  //       }
  //     })
  //     .catch((error) => console.error(error));
  // };

  const getProperties = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append(
        "Authorization",
        `Bearer ${vendorToken}`
      );
      myHeaders.append(
        "Cookie", process.env.REACT_APP_COOKIE
      );

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accomodations/fetch`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const result = await response.json();
      setAllProperties(result?.hotels);
    } catch (error) {
      console.error("Error fetching accommodations:", error);
    }
  };

  useEffect(() => {
    if (userDetails.id) {
      getProperties(userDetails.id);
    }
  }, [userDetails.id]);

  //   useEffect(() => {
  //     const currentPath = location.pathname;
  //     const newPath = currentPath.replace(/\/[^/]*$/, `/${selectedProperty}`);
  //     navigate(newPath);
  // }, [selectedProperty, location.pathname, navigate]);

  const handleOnchange = (id) => {
    // console.log(e.target.value);
    // const property = e.target.value;

    setSelectedProperty(id);
    const currentPath = location.pathname;
    const newPath = currentPath.replace(/\/[^/]*$/, `/${id}`);
    navigate(newPath);
    setShowPropertyDropDown(false);
  };

  const selectedHotel = allProperties?.find(prop => prop.id === Number(propertyId));

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPropertyDropDown(false);
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>

      {/* <select onChange={handleOnchange} value={selectedProperty}>
        <option value="">Select Option</option>
        {allProperties?.map((property, index) => (
          <option key={index} value={property.id}>
            {property?.name.length > 25
              ? `${property?.name.slice(0, 20)}...`
              : property?.name}
          </option>
        ))}
      </select> */}
      {selectedHotel && (
        <div className={styles.selectedPropertyWrapper} ref={popupRef}>
          <div
            className={styles.selectedProperty}
            onClick={() => setShowPropertyDropDown(!showPropertyDropDown)}>
            <div className="flex align_items_center justify_content_between flex_gap_10">
              <h4 className={styles.sdfas}>{selectedHotel?.name}</h4>
              <svg width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
                style={{
                  transform:
                    showPropertyDropDown
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                  transition: "transform 0.3s",
                }}><mask id="mask0_5990_7508" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"><rect y="18" width="18" height="18" transform="rotate(-90 0 18)" fill="#D9D9D9"></rect></mask><g mask="url(#mask0_5990_7508)"><path d="M8.99977 11.1113L14.6493 5.4617C14.7983 5.3127 14.9738 5.24008 15.1756 5.24383C15.3776 5.2477 15.5531 5.32414 15.7021 5.47314C15.8511 5.62227 15.9256 5.79777 15.9256 5.99964C15.9256 6.20152 15.8511 6.37702 15.7021 6.52614L9.96033 12.2794C9.8247 12.415 9.67277 12.5155 9.50452 12.5809C9.33627 12.6463 9.16802 12.679 8.99977 12.679C8.83152 12.679 8.66327 12.6463 8.49502 12.5809C8.32677 12.5155 8.17483 12.415 8.0392 12.2794L2.28577 6.52614C2.13677 6.37702 2.0642 6.19958 2.06808 5.99383C2.07195 5.78808 2.14839 5.6107 2.29739 5.4617C2.44639 5.3127 2.62189 5.2382 2.82389 5.2382C3.02577 5.2382 3.2012 5.3127 3.3502 5.4617L8.99977 11.1113Z" fill="#1C1B1F"></path></g></svg>
            </div>
            <p className={styles.hotelAddress}>{selectedHotel?.address}</p>
          </div>
          {showPropertyDropDown && (
            <div className={styles.propertyList}  >
              {allProperties?.map((property, index) => (
                <div
                  key={index}
                  className={styles.propertyListItem}
                  onClick={() => handleOnchange(property.id)}
                >
                  <div className="flex align_items_center justify_content_between">
                    <h4>{property?.name}</h4>
                    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="new-tab-icon w-5 h-5"
                    ><path d="M5.178 2.667H3.423c-.419 0-.758.398-.758.888v8.89c0 .49.34.888.758.888h8.98c.419 0 .758-.398.758-.889v-.864m-8.042-.403 8.213-8.51m0 0H8.785m4.547 0V8" stroke="#008CFF" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  </div>
                  <p>{property?.address}</p>
                </div>
              ))}

              <div className={styles.viewAllButton}>
                <Link to='/vendor/property/list'>Add Or View All Listings</Link>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ActivePropertySelectBox;
